import React from 'react';
import { useSessionEnded } from '@/context/SessionEndedContext';
import SessionEndedModal from '@/components/SessionEndedModal';
import { userService } from '@/_services';

export default function SessionEndedHost() {
    const { sessionEnded, sessionEndedReason } = useSessionEnded();

    const onLoginAgain = () => {
        userService.clearSessionEndedHold();
        window.location.replace('/login');
    };

    return (
        <SessionEndedModal
            open={sessionEnded}
            onLoginAgain={onLoginAgain}
            accountStatus={sessionEndedReason?.accountStatus}
        />
    );
}
